export enum TypeSearchingBy {
    email,
    name,
    identification,
    none,
}

export class TypeSearchinUtil {
    public static toString(typeSearchingBy: TypeSearchingBy) {
        return TypeSearchingBy[typeSearchingBy];
    }
}